import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { pxToRem } from '@noths/polaris-client-styles';
import * as styles from "./Pointer.styles";
export var Pointer = function Pointer(_ref) {
  var alignment = _ref.alignment,
    pointerCustomLeftValue = _ref.pointerCustomLeftValue;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-alignment": alignment,
    style: {
      '--pointer-custom-value': pointerCustomLeftValue && pxToRem(pointerCustomLeftValue)
    },
    $_css: styles.container
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: styles.pointer
  }));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "Pointer___StyledDiv2",
  componentId: "sc-191im3c-0"
})(["", ""], function (p) {
  return p.$_css2;
});